import {Ball} from "../board/ball";

export class Plate {
  width = 1/5;
  height = 1/30;
  x = 0.5;
  y = 1;
  speed = 0;
  accel = 0;

  move() {
    this.x += this.speed;
    this.speed += this.accel;
    this.accel *= 0.5;
    this.speed *= 0.9;
    if(this.x > 1 - this.width/2) {
      this.x = 1 - this.width/2;
      this.speed *= -1;
      this.accel *= -1;
    }
    if(this.x < this.width/2) {
      this.x = this.width/2;
      this.speed *= -1;
      this.accel *= -1;
    }
  }

  get r(): number { return this.width / 2; }
  get r2(): number { return this.height / 2; }

  normalAt(dx: number) {
    dx /= this.r;
    const angle = Math.asin(dx);
    const dy = - Math.max(0.05, Math.cos(angle) * this.r / this.r2);
    let vect = [dx, dy];

    const size = Math.sqrt(vect.map(v=> v*v).reduce((r,v)=>r+v,0));
    vect = vect.map(v=>v/size);
    if(Number.isNaN(vect[0])) {
      console.log(dx, angle, dy, vect, size)
    }
    return vect;
  }

  interact(ball: Ball) {
    const limitY = this.y - ball.r;
    let dx = ball.x - this.x;
    ball.rebound(this.normalAt(dx),[ball.x, limitY]);
  }

  inRange(ball: Ball) {
    return (ball.x >= this.x - this.r) && (ball.x <= this.x + this.r );

  }
}
